
export function loadEventsForEdit () {
    this.eventEditTarget = this.env.getPageInfo('admin-event-edit-target');
    console.log('loadEventsForEdit', this.eventEditTarget);
}

export function saveEventsForEdit () {
    this.env.setPageInfo('admin-event-edit-target', this.eventEditTarget);
}
